/** Banner — document knowledge definition. Pure data. */
export default {
  id: 'banner',
  name: 'Banner',
  description: 'A wide promotional strip for websites, storefronts, and campaigns.',
  purpose: 'Promotion & Visibility',
  recommendedSizes: [
    { name: 'Web Banner', width: 1500, height: 500, unit: 'px' },
    { name: 'Leaderboard', width: 728, height: 90, unit: 'px' },
  ],
  supportedOrientations: ['landscape'],
  supportsMultiplePages: false,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Headline', 'Subtext', 'CTA', 'Brand'],
};
